export default __webpack_public_path__ + "static/media/jrlobsteronchair.8cf38569.png";